import { render, staticRenderFns } from "./Card-study.vue?vue&type=template&id=63482044&"
import script from "./Card-study.vue?vue&type=script&lang=js&"
export * from "./Card-study.vue?vue&type=script&lang=js&"
import style0 from "./Card-study.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports